import React from 'react';

import {humanJoin} from '../utils/human-join';

type Props = {
	originalTitle?: string | null;
	alternativeTitles?: Array<string | null> | null;
};

/**
 * Строка «Другие названия». Оригинал помечен lang="en", чтобы экранный диктор
 * прочитал его по-английски, а не русскими правилами.
 */
export const OtherTitles: React.FC<Props> = ({originalTitle, alternativeTitles}) => {
	const titles = [
		originalTitle ? (
			<span lang="en" key="original">
				{originalTitle}
			</span>
		) : null,
		...(alternativeTitles || []).filter(Boolean).map((title) => <span key={title!}>{title}</span>),
	].filter(Boolean) as React.ReactNode[];

	if (!titles.length) return null;

	return (
		<p>
			<b>Другие названия:</b> {humanJoin(titles)}.
		</p>
	);
};
